<template>
  <div class="chart-container" :style="{ height: height + 'px' }">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { markRaw } from "vue";

export default {
  name: "DashboardChart",
  props: {
    height: {
      type: [Number, String],
      default: 300,
    },
    type: {
      type: String,
      default: "line",
    },
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  watch: {
    data: {
      handler(newData) {
        if (newData) {
          this.$nextTick(() => {
            this.updateChart();
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.chartInstance = null; // Initialize non-reactive property
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    initChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }

      if (!this.$refs.chartCanvas) return;

      const ctx = this.$refs.chartCanvas.getContext("2d");

      this.chartInstance = markRaw(
        new Chart(ctx, {
          type: this.type,
          data: this.data,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            ...this.options,
          },
        })
      );
    },
    updateChart() {
      if (!this.chartInstance) {
        this.initChart();
        return;
      }

      // Safety check: if canvas is gone, don't update
      if (!this.$refs.chartCanvas) return;

      this.chartInstance.data = this.data;
      this.chartInstance.update();
    },
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  position: relative;
}
</style>
